{
  "nl": {
    "announcement": {
      "actions": {
        "delete_announcement": "Verwijder Nieuwsbericht",
        "edit": "Bewerken",
        "new": "Nieuwsbericht",
        "pin": "Vastzetten bovenaan",
        "save": "Opslaan",
        "submit": "Post",
        "unpin": "Losmaken"
      },
      "attributes": {
        "description": "Omschrijving"
      },
      "labels": {
        "allUnits": "alle units",
        "customers": "",
        "for": "in het",
        "image_tab": "Afbeelding",
        "notSeenYet": "Nog niet gezien",
        "now": "Nu",
        "pinned": "Dit bericht wordt bovenaan de pagina van de klant getoond.",
        "pinnedBadge": "Vastgezet",
        "seen": "Gezien",
        "seenByCount": "Gezien door {count} van {total}",
        "sharedWithPrefix": "Gedeeld met",
        "sharedWithProject": "Gedeeld met {units} van {project}",
        "someUnits": "sommige units",
        "start": "Start",
        "unitsCount": "1 Unit | {count} Units",
        "video_tab": "Video",
        "youtube_video": "YouTube video URL"
      },
      "name": "Nieuwsbericht",
      "placeholders": {
        "customers": {
          "none": {
            "subtitle": "Binnenkort vind je hier regelmatige updates terug over de werf.",
            "title": "Ontvang hier je nieuws!"
          }
        },
        "employees": {
          "new": {
            "subtitle": "Verwelkom jouw klanten of deel een eerste update over het project.",
            "title": "Plaats je eerste nieuwsbericht"
          },
          "none": {
            "project_required": "Selecteer een project",
            "selectProject": "Selecteer een project en begin met creëren!",
            "subtitle": "Verwelkom jouw klanten of deel een eerste update over een project."
          },
          "paste_video_url": "Plak hier je YouTube video link"
        }
      },
      "toasts": {
        "create": "Nieuwsbericht gepubliceerd",
        "delete": "Nieuwsbericht verwijderd",
        "invalid_video": "Dit is geen geldige YouTube video",
        "update": "Nieuwsbericht is gewijzigd"
      },
      "validation": {
        "pleaseAddContent": "Voeg een afbeelding, video of omschrijving toe"
      }
    }
  }
}
